import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardActions,
  Paper,
  Button,
  FormControlLabel,
  Checkbox,
  Switch,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { TableContainer, Table, TableCell, TableHead, TableRow, TableBody } from "@mui/material";
import { Dialog, DialogContent, DialogTitle, DialogActions, Stack, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { makeStyles } from "@mui/styles";
import { endpoint } from "./config";
import axios from "axios";
import { format } from "date-fns";
import $ from "jquery";
import "parsleyjs";
import "jquery-confirm/dist/jquery-confirm.min";
import "jquery-confirm/dist/jquery-confirm.min.css";
import { decrypt, encrypt } from './AesUtil';



const useStyles = makeStyles({
  closeButton: {
    position: "absolute !important",
    right: 5,
    top: 5,
  },
  dialogPaper: {
    maxHeight: "65vh",
  },
});

function AddUser() {
  const params = useParams();
  const navigate = useNavigate();

  const [assignedProjects, setAssignedProjects] = useState([]);
  const [modal, setModal] = useState(false);
  const [EditMode, setEditMode] = useState(false);
  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [state, setState] = useState({
    emailId: "",
    password: "",
    repeatPassword: "",
    userName: "",
    userType: "Administrator",
    //userType: "Employee",
    status: true,
    employeeId: "0",
    employeeName: "",
    designation: "",
    contactNo: "",
    manager: "",
    billingStartDate: format(new Date(), "yyyy-MM-dd"),
    billingEndDate: "",
    weekendOff: true,
    maxWeeklyHours: "40",
  });

  
  const [editUserId, setUserId] = useState(0);
  
  
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const classes = useStyles();

  const toggle = () => {
    setModal(!modal);
  };

  useEffect(()=>{
    if (params.id){
      setEditMode(true);
      setUserId(params.id);
      fetchUser(params.id);
    }
  }, [params]);

  async function fetchUser(userId){
    const response = await axios.get(`${endpoint}/users/${userId}`);
    console.log(response.data);
    if (response.data.status){
      const user = response.data.user;
      const employee = response.data.employee;
      let password = decrypt(decodeURIComponent(response.data.userPassword));
      console.log(response.data);
      

      if (employee){
        setState({...state, emailId: user.emailId,'password': password,'repeatPassword': password,userName: user.userName,
              userType: user.userType,status: user.status===1,
              employeeId: employee.employeeId || '0',
              employeeName: employee.employeeName || '',
              designation: employee.designation || '',
              contactNo: employee.mobileNo || '',manager: employee.manager || '',
              billingStartDate: employee.billingStartDate,billingEndDate: employee.billingEndDate,
              weekendOff: employee.weekendOff===1,maxWeeklyHours: employee.maxWeeklyHours,});
        
        const projects = employee.assignedProjects;
        let array = [];
        projects.map(project => {
          let tasks = project.assignedTasks;
          tasks.map( task => {
            array.push({'projectId': project.projectId, 'projectName': project.project.projectName, 'projectRate': project.rate,
                        'taskId': task.taskId, 'taskName': task.task.taskName + ' - ' + task.task.description, 'taskRate': task.rate});
            return task;
          });
          
          return project;
        });
        setAssignedProjects(array);

      }else{
        setState({...state, emailId: user.emailId,'password': password,'repeatPassword': password,userName: user.userName,
              userType: user.userType,status: user.status===1,});
      }
    }else{
      $.alert(response.data.error);
      navigate(-1);
    }
  }
  

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData(){
    
    const response1 = await axios.get(`${endpoint}/projects`);
    setProjects(response1.data.data);

    const response2 = await axios.get(`${endpoint}/tasks`);
    setTasks(response2.data.data);

  }

  const handleChange = (event) => {
    if (event.target.type === "checkbox") {
      setState({ ...state, [event.target.name]: event.target.checked });
    } else {
      setState({ ...state, [event.target.name]: event.target.value });
    }
  };

  const userNameChange = (event) =>{
    setState({ ...state, [event.target.name]: event.target.value, "employeeName": event.target.value });
  }

  const projectChange = (event) =>{
    setState({ ...state, [event.target.name]: event.target.value, "projectName": $(event.target).children(":selected").text() });
  }

  const taskChange = (event) =>{
    setState({ ...state, [event.target.name]: event.target.value, "taskName": $(event.target).children(":selected").text() });
  }


  const addProject = () => {
    let tempArray = [...assignedProjects];
    tempArray.push({
      projectId: state.projectId,
      projectName: state.projectName,
      projectRate: state.projectRate,
      taskId: state.taskId,
      taskName: state.taskName,
      taskRate: state.taskRate,
    });

    setAssignedProjects(tempArray);
    setModal(false);

    setState({...state, projectId: "", projectRate: "", taskId: "", taskRate: "" });
  };

  const saveData = async () => {
    let addform = $("#formAdd");
    addform.parsley();

    if (addform.parsley().validate()){
        addform.parsley().reset();
    }else{
        return;
    }

    if (addform.parsley().isValid()) {
      //addform.parsley().reset();
      //console.log("valid");
      //setError("");
    } else {
      //console.log("invalid");
      //setError("All fields are mandatory, valid entries 0 to 8.");
      return false;
    }

    if (state.userType==="Employee"){
      if (assignedProjects.length===0){
        $.alert({title: "", content:'Please assign at least one project.', columnClass: 'small'});
        return false;
      }
    }

    let form = document.forms.namedItem("formAdd");
    let params = new FormData(form);

    params.append('userId', editUserId);
    params.append('employeeId', state.employeeId);

    params.delete("userType");
    params.append("userType", state.userType);

    params.delete("status");
    params.append("status", (state.status===true ? 1:0));

    params.delete("weekendOff");
    params.append("weekendOff", (state.weekendOff===true ? 1:0));
    
    params.append("assignedProjects", JSON.stringify(assignedProjects));

    const response = await axios.post(`${endpoint}/user/save`, params);
    const data = response.data;
    if (data.status) {
      //toast("Hours Saved.");
      console.log("Data saved");
      navigate("/users");
    } else {
      $.alert(data.error);
      console.error(data.error);
    }
    
  }
  
  const onDeleteRow = (row, index) =>{
    let clone = [...assignedProjects];
    clone.splice(index, 1);
    setAssignedProjects(clone);
    console.log(row);
};

  return (
    <>
      <header className="page-title-bar flex mb-3">
        <h1 className="page-title mr-sm-auto mb-0"> {EditMode ? 'Edit':'Add'} User </h1>
      </header>

      <Card>
        <CardContent className="pt-4">
          <form id="formAdd" autoComplete="off">
            <Grid container spacing={2} className="form-group">
              <Grid lg={3} md={4} xs={12}>
                <label className="required">Full Name</label>
              </Grid>
              <Grid lg={4} md={6} xs={12}>
                <input
                  type="text"
                  name="userName"
                  className="form-control"
                  required
                  value={state.userName}
                  onChange={userNameChange}
                ></input>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={3} md={4} xs={12}>
                <label className="required">Email ID</label>
              </Grid>
              <Grid lg={4} md={6} xs={12}>
                <input
                  type="email"
                  name="emailId"
                  className="form-control"
                  required
                  value={state.emailId || ""}
                  onChange={handleChange}
                  autoComplete="new-password"
                ></input>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={3} md={4} xs={12}>
                <label className="required">Password</label>
              </Grid>
              <Grid lg={4} md={6} xs={12}>
                <input
                  id="pw"
                  type="password"
                  name="password"
                  className="form-control"
                  required
                  value={state.password || ""}
                  onChange={handleChange}
                  autoComplete="new-password"
                ></input>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={3} md={4} xs={12}>
                <label className="required">Confirm Password</label>
              </Grid>
              <Grid lg={4} md={6} xs={12}>
                <input
                  type="password"
                  className="form-control"
                  name="repeatPassword"
                  required
                  value={state.repeatPassword}
                  onChange={handleChange}
                  data-parsley-equalto="#pw"
                  data-parsley-error-message={"Retype password must be same as Password!"}
                ></input>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={3} md={4} xs={12}>
                <label>User Type</label>
              </Grid>
              <Grid lg={3} md={6} xs={12}>
                <select
                  className="form-select form-control"
                  name="userType"
                  value={state.userType}
                  onChange={handleChange}
                  disabled={EditMode}
                >
                  <option value={"Administrator"}>Administrator</option>
                  <option value={"Employee"}>Employee</option>
                  <option value={"Manager"}>Manager</option>
                  <option value={"Vendor"}>Vendor</option>
                </select>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group align-center">
              <Grid lg={3} md={4} xs={12}>
                <label>Status</label>
              </Grid>
              <Grid lg={3} md={6} xs={12}>
                <FormControlLabel
                  control={<Switch name="status" color="success" checked={state.status} onChange={handleChange} />}
                  label="Active"
                />
              </Grid>
            </Grid>

            {state.userType === "Employee" && (
              <div className="mb-5">
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label className="required">Employee Name</label>
                  </Grid>
                  <Grid lg={5} md={6} xs={12}>
                    <input
                      type="text"
                      name="employeeName"
                      className="form-control"
                      required
                      value={state.employeeName}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label>Designation</label>
                  </Grid>
                  <Grid lg={4} md={6} xs={12}>
                    <input
                      type="text"
                      name="designation"
                      className="form-control"
                      value={state.designation}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label>Contact No.</label>
                  </Grid>
                  <Grid lg={3} md={6} xs={12}>
                    <input
                      type="text"
                      name="contactNo"
                      className="form-control"
                      value={state.contactNo}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label className="required">Manager</label>
                  </Grid>
                  <Grid lg={4} md={6} xs={12}>
                    <input
                      type="text"
                      name="manager"
                      className="form-control"
                      required
                      value={state.manager}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label className="required">Billing Start Date</label>
                  </Grid>
                  <Grid lg={3} md={6} xs={12}>
                    <input
                      type="date"
                      name="billingStartDate"
                      className="form-control"
                      required
                      value={state.billingStartDate}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label className="required">Billing End Date</label>
                  </Grid>
                  <Grid lg={3} md={6} xs={12}>
                    <input
                      type="date"
                      name="billingEndDate"
                      className="form-control"
                      required
                      value={state.billingEndDate}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}></Grid>
                  <Grid lg={3} md={6} xs={12}>
                    <FormControlLabel
                      control={<Checkbox name="weekendOff" checked={state.weekendOff} onChange={handleChange} />}
                      label="Weekend Off"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="form-group">
                  <Grid lg={3} md={4} xs={12}>
                    <label>Max. Weekly Hours</label>
                  </Grid>
                  <Grid lg={2} md={6} xs={12}>
                    <input
                      type="number"
                      name="maxWeeklyHours"
                      className="form-control"
                      value={state.maxWeeklyHours}
                      onChange={handleChange}
                    ></input>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className="form-group">
                  <Grid lg={8} md={12} xs={12}>
                    <div className="flex justify-between align-center mb-3 mt-3">
                      <Typography variant="subtitle2">Assigned Projects</Typography>
                      <Button size="small" variant="outlined" onClick={toggle}>
                        Assign Project
                      </Button>
                    </div>
                    <TableContainer size={"medium"}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>Project Name</TableCell>
                            <TableCell align="right">Project Rate</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>Task Name</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }} align="right">
                              Task Rate
                            </TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {assignedProjects.map((row, key) => (
                            <TableRow hover key={key}>
                              <TableCell scope="row" sx={{whiteSpace: "nowrap"}}>{row.projectName}</TableCell>
                              <TableCell align="right">{row.projectRate}</TableCell>
                              <TableCell>{row.taskName}</TableCell>
                              <TableCell align="right">{row.taskRate}</TableCell>
                              <TableCell>
                                <IconButton onClick={()=>onDeleteRow(row, key)}>
                                  <DeleteIcon fontSize={"small"} />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </div>
            )}

            <Grid container spacing={2} className="form-group">
              <Grid lg={3} md={4} xs={12}>
              </Grid>
              <Grid lg={3} md={6} xs={12}>
                <Stack direction="row" spacing={2}>
                  <Button size="small" variant="outlined" onClick={()=>{navigate(-1);}}>
                    Cancel
                  </Button>
                  <Button size="small" variant="contained" onClick={saveData}>
                    {EditMode ? 'Update & Close':'Save & Close'}
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      <Dialog
        id={"modal"}
        disableEscapeKeyDown
        disableEnforceFocus
        scroll="paper"
        maxWidth={"sm"}
        fullWidth={true}
        fullScreen={fullScreen}
        open={modal}
        onClose={toggle}
      >
        <DialogTitle sx={{ padding: "10px 20px" }}>
          Assign Project
          {
            <IconButton aria-label="close" className={classes.closeButton} onClick={toggle}>
              <CloseIcon fontSize={"small"} />
            </IconButton>
          }
        </DialogTitle>

        <DialogContent dividers={true} style={{ overflowX: "hidden" }} className={classes.dialogPaper}>
          <form id={"addProject"}>
            <input type="hidden" name="employeeId"></input>
            <Grid container spacing={2} className="form-group">
              <Grid lg={4} md={4} xs={12}>
                <label className="required">Project Name</label>
              </Grid>
              <Grid lg={8} md={6} xs={12}>
                <select
                  className="form-select form-control"
                  name="projectId"
                  required
                  value={state.projectId}
                  onChange={projectChange}
                >
                  <option value={""}>Select Project</option>
                  {projects &&
                    projects.map((row) => {
                      return <option key={row.projectId} value={row.projectId}>{row.projectName}</option>;
                    })}
                </select>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={4} md={4} xs={12}>
                <label className="required">Project Rate</label>
              </Grid>
              <Grid lg={4} md={6} xs={12}>
                <input
                  type="number"
                  className="form-control"
                  name="projectRate"
                  required
                  value={state.projectRate}
                  onChange={handleChange}
                ></input>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={4} md={4} xs={12}>
                <label className="required">Task Name</label>
              </Grid>
              <Grid lg={8} md={6} xs={12}>
                <select className="form-select form-control" name="taskId" value={state.taskId} onChange={taskChange}>
                  <option value={""}>Select Task</option>
                  {tasks &&
                    tasks.map((row) => {
                      return <option key={row.taskId} value={row.taskId}>{row.taskName + " - " + row.description}</option>;
                    })}
                </select>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="form-group">
              <Grid lg={4} md={4} xs={12}>
                <label className="required">Task Rate</label>
              </Grid>
              <Grid lg={4} md={6} xs={12}>
                <input
                  type="number"
                  className="form-control"
                  name="taskRate"
                  value={state.taskRate}
                  onChange={handleChange}
                  required
                ></input>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions sx={{ padding: "12px" }}>
          <Stack direction="row" spacing={2}>
            <Button size="small" variant="contained" onClick={addProject}>
              Add
            </Button>
            <Button size="small" variant="outlined" onClick={toggle}>
              Cancel
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AddUser;
